export const enum widgetNameClasses {
  playback = 'js-episode-playback',
  offers = 'js-episode-offers',
}